// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ModalSheetHeroHeader__root___iwDBr","bordered":"ModalSheetHeroHeader__bordered___YTs3V","closeBtnContainer":"ModalSheetHeroHeader__closeBtnContainer___N00DS"};